import { spaceOfBlock, type PlacementSpace } from '@vrlearning/lesson-schema';
import type { WorldSource } from '../render/worlds/source.js';

/**
 * Where a lesson's pupils may place their work (V10): a package's plaatsruimte, or none. The code
 * villa's plan went with the code villa (12 Oct 2026): its package says the same space.
 */
export function placementSpaceOf(source: WorldSource | undefined): PlacementSpace | undefined {
  if (source?.kind !== 'pakket') return undefined;
  const pkg = source.servedPackage;
  const block = pkg?.blocks.find((b) => b.type === 'plaatsruimte');
  return pkg && block?.type === 'plaatsruimte' ? spaceOfBlock(pkg.slug, block) : undefined;
}
